import React, { useState } from 'react';
import '../assets/styles/DownloadConfirmationModal.css';

export const DownloadConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
    const [step, setStep] = useState("confirm");
    const [name, setName] = useState("");

    if (!isOpen) return null;

    const resetAndClose = () => {
        setStep("confirm");
        setName("");
        onClose();
    };

    const handleYes = () => {
        setStep("name");
    };

    const handleNo = () => {
        resetAndClose();
    };

    const handleDownload = () => {
        onConfirm(name);
        resetAndClose();
    };

    return (
        <div className="modal-overlay" onClick={handleNo}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className="modal-close-btn" onClick={handleNo} aria-label="Close modal">
                    &times;
                </button>

                {/* Liquid Glass Background Orbs */}
                <div className="modal-liquid-bg">
                    <div className="liquid-orb orb-1"></div>
                    <div className="liquid-orb orb-2"></div>
                    <div className="liquid-orb orb-3"></div>
                </div>

                {/* Animated Download Icon */}
                <div className="question-icon-wrapper">
                    <div className="question-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                    </div>
                </div>

                {/* Confirmation Message */}
                <h2 className="modal-title">
                    {step === "confirm" ? "Download CV and Cover Letter?" : "Enter Your Name"}
                </h2>
                <p className="modal-message">
                    {step === "confirm"
                        ? "Would you like to download Ushan's CV and cover letter? I'll be notified about your interest!"
                        : "Please share your name so I can log your download."}
                </p>

                {step === "confirm" && (
                    <div className="modal-info">
                        <p className="info-text">
                            <span className="info-icon">📧</span>
                            Email notification will be sent
                        </p>
                    </div>
                )}

                {/* Yes/No Buttons */}
                {step === "name" && (
                    <div className="modal-info">
                        <input
                            className="modal-name-input"
                            type="text"
                            placeholder="Full name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                )}

                <div className="modal-buttons">
                    <button className="modal-btn modal-btn-no" onClick={handleNo}>
                        <span>{step === "confirm" ? "No, Thanks" : "Cancel"}</span>
                    </button>
                    <button
                        className="modal-btn modal-btn-yes"
                        onClick={step === "confirm" ? handleYes : handleDownload}
                        disabled={step === "name" && !name.trim()}
                    >
                        <span>{step === "confirm" ? "Yes, Continue" : "Download"}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
